;(function (angular) {
   'use strict'

   angular.module('azure.data').factory('searchQueryData', searchQueryData)

   function searchQueryData(CacheFactory, util) {
      //================================================================================
      // Cache
      //================================================================================

      const getCacheKey = util.joinArgs

      const _localStorage = CacheFactory.createCache('localSearchQueries', {
         storageMode: 'localStorage',
         maxAge: Number.MAX_VALUE,
      })

      const _keyLocalSearchQueries = 0

      //================================================================================

      function getSearchQueries(userId) {
         const cacheKey = getCacheKey(_keyLocalSearchQueries, userId)
         const maybeExistingQueriesObj = _localStorage.get(cacheKey)
         return maybeExistingQueriesObj || {}
      }

      function saveOrUpdateSearchQuery(userId, query) {
         const queriesObj = getSearchQueries(userId)

         queriesObj[query] = queriesObj[query] + 1 || 1

         _localStorage.put(getCacheKey(_keyLocalSearchQueries, userId), queriesObj)
      }

      function removeSearchQuery(userId, query) {
         const queriesObj = getSearchQueries(userId)

         delete queriesObj[query]

         _localStorage.put(getCacheKey(_keyLocalSearchQueries, userId), queriesObj)
      }

      //================================================================================

      return {
         getSearchQueries: getSearchQueries,
         saveOrUpdateSearchQuery: saveOrUpdateSearchQuery,
         removeSearchQuery: removeSearchQuery,
      }
   }
})(angular)
